import React from 'react'
import TextComponent from '../TextComponent';

const PressureHolderQuantity = (props) => {
  const onChange = e => props.onChangeParameter(props.name, e.target.value);
  const value = props.parameters[props.name];
  return (
    <TextComponent
      label={props.label}
      name={props.name}
      inputId={props.inputId}
      value={value || ''}
      required={props.required}
      onChange={onChange}
      tooltip={props.tooltip}
      min="1">
      {props.children}
    </TextComponent>
  )
}

PressureHolderQuantity.defaultProps = {
  label: 'Total Number of Pressure Holders',
  name: 'pressure_holder_quantity',
};

export default PressureHolderQuantity;
